<template>
    <div class="shop__discountcode shop__options-block" v-if="ShowDiscountCodePicker">
        <div class="shop__options-block-input">
            <InputWithLabel :label="Strings['Shop.LabelDiscountCode']"
                            :value="CurrentTransaction.discountCode"
                            :cssclass="{'migrol-form__input-wrapper--error' : IsCouponInvalid, 'migrol-form__input-wrapper--success' : IsCouponValid}"
                            :disabled="IsPartnerLink"
                            @input="newVal => newVal = newVal.toUpperCase()"
                            @change="updateDiscountCode" >
                <slot></slot>
            </InputWithLabel>
            <div class="shop__error-message" v-show="IsCouponInvalid">{{Strings['Shop.Errors.InvalidCoupon']}}</div>
            <div class="shop__success-message shop__success-message--inverted" v-show="IsCouponValid">{{Strings['Shop.CouponValid']}}</div>
        </div>
        <div class="shop__options-block-desc">
            <!-- hidden label for spacing -->
            <label class="migrol-form__input-label migrol-form__input-label--invisible">{{Strings['Shop.LabelDeliveryPeriod']}}</label>
            <span>{{Strings['Shop.DiscountCodeDescription']}}</span>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import Transaction from '@/models/Transaction'
    import { PriceRequestOutcomes } from '@/utils/constants';

    export default {
        computed: {
            ...mapState([
                'Strings',
                'ServerErrormessages',
                'IsPartnerLink',
                'PriceCalculationOutcome'
            ]),
            CurrentTransaction() {
                return Transaction.query().with('positions').first();
            },
            ShowDiscountCodePicker() {
                //hide for multiple UP, campaigns, and partner links
                return this.CurrentTransaction.positions.length == 1 && !this.CurrentTransaction.isCampaignOffer;
            },
            IsCouponInvalid() {
                return this.PriceCalculationOutcome != null && this.PriceCalculationOutcome == PriceRequestOutcomes.CouponInvalid;
            },
            IsCouponValid() {
                return this.PriceCalculationOutcome != null && this.CurrentTransaction.discountCode && this.PriceCalculationOutcome != PriceRequestOutcomes.CouponInvalid;
            }
        },
        methods: {
            updateDiscountCode(newVal) {
                Transaction.update({
                    id: this.CurrentTransaction.id,
                    discountCode: newVal
                });
            }
        },
        components: {
            
        }
    };
</script>